// extracted by mini-css-extract-plugin
export default {"wrapper":"status_wrapper__MXVl4","status":"status_status__oLZ4f","high":"status_high__Hf76H","medium":"status_medium__PDeuu","low":"status_low__9-4iy"};